import { currentUser, currentUserLoaded } from 'app/modules/user/selectors'
import { createSelector } from 'reselect'

export const isInDriftIntelTrial = state => state.getIn(['gates', 'drift_intel_trial_started'])
export const getGates = state => currentUserLoaded(state) && currentUser(state).gates
export const makeHasGate = gate => createSelector(getGates, gates => gates && gates.get(gate))
export const hasStandardTrial = makeHasGate('standard_trial')
export const hasProPlan = makeHasGate('premium_team')
export const hasStarterPlan = makeHasGate('premium_drift')
export const hasCompanyPlan = makeHasGate('premium_enterprise')
export const isOnStandardPlan = createSelector([
  hasStarterPlan,
  hasProPlan,
  hasCompanyPlan
], (
  hasStarterPlan,
  hasProPlan,
  hasCompanyPlan
) => hasStarterPlan && !hasProPlan && !hasCompanyPlan)
export const isOnFreePlan = createSelector([
  hasProPlan,
  hasStarterPlan,
  hasCompanyPlan,
  hasStandardTrial,
], (
  hasProPlan,
  hasStarterPlan,
  hasCompanyPlan,
  hasStandardTrial,
) => [hasProPlan, hasStarterPlan, hasCompanyPlan, hasStandardTrial].every(isOnPlan => !isOnPlan))
export const hasOutboundPlaybooksGate = state => makeHasGate('outbound_playbooks')(state)
export const hasCentralizedRouting = makeHasGate('CENTRALIZED_ROUTING')
export const hasLimitNumberOfChats = makeHasGate('has_limit_num_chats')
export const hasBulkMessageRead = state => makeHasGate('has_bulk_message_read')(state)
export const hasSequenceTestEmail = makeHasGate('has_sequence_test_email')
export const hasDemoOrg = state => makeHasGate('has_demo_org')(state)
export const hasNewConversationReports = makeHasGate('has_new_conversation_reports')
export const hasMarketingSequence = makeHasGate('has_marketing_sequences')
export const hasSalesCalendaring = makeHasGate('has_sales_calendaring')
export const hasMeetings = makeHasGate('has_meetings')
export const hasTeamHours = makeHasGate('has_team_hours')
export const hasSplitEndUserChannel = makeHasGate('has_split_end_user_channel')
export const hasPresence = makeHasGate('has_presence')
export const hasMadKudu = makeHasGate('has_madkudu')
export const hasWidgetCustomization = makeHasGate('has_widget_customization')
export const hasNewConvoExport = makeHasGate('has_new_convo_export')
export const hasBetaBulkClose = makeHasGate('beta_bulk_close')
export const hasNewSendFlow = makeHasGate('has_new_send_flow')
export const hasCompactConversationHeader = makeHasGate('has_compact_conversation_header')
export const hasClearbitReveal = makeHasGate('has_reveal')
export const hasBetaEnrichment = makeHasGate('has_beta_enrichment')
export const hasBetaGlobalCalendars = makeHasGate('has_beta_global_calendars')
export const hasPublicShiypard = makeHasGate('has_public_shipyard')
export const hasConversationRatingAgentDrop = makeHasGate('has_conversation_rating_drop')
export const hasWebSocketChatNotifications = makeHasGate('web_socket_chat_notifications')
export const hasInviteViaRoundRobinToTeam = makeHasGate('invite_via_round_robin_to_team_beta')
export const hasClassificationNotifications = makeHasGate('has_classification_notifications')
export const hasInboxFilterSidebar = makeHasGate('has_inbox_filter_sidebar')
export const killOneTimeEmailSends = makeHasGate('kill_one_time_email_sends')
export const hasNewConversationSidebar = makeHasGate('NEW_CONVERSATION_SIDEBAR')
export const disableNewMessageComposer = makeHasGate('disable_new_message_composer')
export const canUseCompanyTags = makeHasGate('can_use_company_tags')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/gates/selectors.js